import React, { useState, useEffect } from "react";
import useMessage from "hooks/useMessage";
import useExceptionHandler from "hooks/useExceptionHandler";
import EditSection from "components/PantallasEdit/EditSection/EditSection";
import { Button, Form, Row, Col } from "react-bootstrap";
import { ConfiguracionEmailHelper } from "utils";
import { ConfiguracionCorreoElectronicoManager } from "managers";

function VincularCuentaSendGrid({
    showLoading,
    hideLoading,
    configuracionEmail,
    setConfiguracionEmail,
    setTipoActual,
    tipoActual,
    fuente,
    referencia,
    esAutomatizacion = false,
    authResponse,
    setAuthResponse,
}) {
  const { Message } = useMessage();
  const { handleException } = useExceptionHandler();
  const [apiKey, setApiKey] = useState("");

  const handleVincular = () => {
    showLoading();
    ConfiguracionCorreoElectronicoManager.vincularCorreoSendGrid({
      SendGridApiKey: apiKey,
    })
      .then((data) => {
        setConfiguracionEmail(data);
        setTipoActual(data.Tipo);
        Message({ message: "Correo SendGrid vinculada exitosamente." });
      })
      .catch(handleException)
      .finally(hideLoading);
  };

  const handleDesvincular = () => {
    showLoading();
    ConfiguracionCorreoElectronicoManager.desvincularCuentaSendGrid()
      .then((data) => {
        setConfiguracionEmail(data);
        setTipoActual(data.Tipo);
        Message({ message: "Correo SendGrid desvinculada exitosamente." });
      })
      .catch(handleException)
      .finally(hideLoading);
  };

  return (
    <EditSection>
      {configuracionEmail.EmailRegistrado &&
      tipoActual === ConfiguracionEmailHelper.TIPO_SERVIDOR_CORREO.SENDGRID ? (
        <Row>
          <Form.Label column sm="2">Cuenta Vinculada</Form.Label>
          <Col sm="6">
            <Form.Control
              disabled
              value={configuracionEmail.EmailRegistrado}
              placeholder="Email vinculado"
            />
            <Button
              variant="link"
              className="p-0 mt-2 text-primary"
              onClick={handleDesvincular}
            >
              Desvincular Correo SendGrid
            </Button>
          </Col>
        </Row>
      ) : (
        <Row>
          <Form.Label column sm="2">ApiKey</Form.Label>
          <Col sm="6">
            <Form.Control
              value={apiKey}
              placeholder="Ingrese la ApiKey"
              onChange={(e) => setApiKey(e.target.value)}
            />
            <Button
              variant="link"
              className="p-0 mt-2 text-primary"
              onClick={handleVincular}
            >
              Vincular Correo SendGrid
            </Button>
          </Col>
        </Row>
      )}
    </EditSection>
  );
}

export default VincularCuentaSendGrid;
